import React from 'react';

import { PlaidContext } from 'src/components/atomic/pages/onboarding/OnboardingDrawer';
import PlaidButton from 'src/bw/bw-drawer/PlaidButton';

/**
 * @deprecated Use PlaidConnector instead.
 */
export default function ConnectAccountsButton(): JSX.Element {
    return (
        <PlaidContext.Consumer>
            {(ctx) => (
                <PlaidButton
                    noMargin
                    handleClearFirstImport={ctx.handleClearFirstImport}
                    handleFirstImport={ctx.handleFirstImport}
                    handleReloadUser={ctx.handleReloadUser}
                    firstImport={ctx.firstImport}
                    user={ctx.user}
                    showLoader={ctx.showLoader}
                    hideLoader={ctx.hideLoader}
                    handleTopDrawer={ctx.handleTopDrawer}
                    handleAccounts={ctx.handleAccounts}
                />
            )}
        </PlaidContext.Consumer>
    );
}
